import React from "react";
import { Routes, Route } from "react-router";
import WaitingRoom from "../screens/WaitingRoom";
import Consult from "../screens/Consult";
import ConsultComplete from "../screens/ConsultComplete";
import ConsultLinkExpired from "../screens/ConsultLinkExpired";
import CloseTab from "../screens/CloseDuplicates";
import PageNotFound from "../screens/PageNotFound";

export default function TelehealthRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PageNotFound />} />
      <Route path="/:cid" element={<WaitingRoom />} />
      <Route path="/consult/:cid" element={<Consult />} />
      <Route path="/consult-complete" element={<ConsultComplete onLeaveOrJoinSession={() => {}} />} />
      <Route path="/consult-expired/:cid" element={<ConsultLinkExpired />} />
      <Route path="/close-tab" element={<CloseTab />} />
    </Routes>
  );
}
